import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = () => {
  return (
    <section className="bg-gradient-to-br from-primary via-brand-primary to-accent text-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="Clock" size={16} color="white" />
            <span className="text-sm font-medium">24/7 Verfügbar</span>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-balance">
            Sofortige Rechtsberatung
            <span className="block text-conversion-accent">Jederzeit verfügbar</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-white/90 mb-8 max-w-3xl mx-auto text-balance">
            Professionelle Rechtsberatung per Telefon - transparent, zugänglich und sofort verfügbar. 
            Keine Wartezeiten, keine versteckten Kosten.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button
              variant="default"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              className="bg-conversion-accent hover:bg-cta text-white cta-button text-lg px-8 py-4"
              onClick={() => window.location.href = 'tel:09001000312'}
            >
              Jetzt anrufen - Sofort sprechen
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              className="border-white text-white hover:bg-white hover:text-primary text-lg px-8 py-4"
            >
              Termin vereinbaren
            </Button>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-6 text-white/80">
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} />
              <span className="text-sm">Vertraulich & Sicher</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Scale" size={16} />
              <span className="text-sm">Zugelassene Rechtsanwälte</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Euro" size={16} />
              <span className="text-sm">Transparente Preise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;